<template>
  <div class="section-block">
    <div class="block1-list">
      <van-list
        v-model="postState.loading"
        :finished="postState && postState.finished"
        :finished-text="postState.finishText"
        @load="handleGetPostList"
      >
        <div v-if="postListArr.length > 0">
          <div
            class="block1-item"
            v-for="(item, index) in postListArr"
            :key="index"
            @click="handleClickItems(item)"
          >
            <template v-if="item.type == 4 && changeActive == 1">
              <img
                src="@/assets/images/zone/img25.png"
                v-if="item.areaPostbarWorkDataDTOS.length > 0"
                class="icon-tag"
                alt=""
              />
              <img
                src="@/assets/images/zone/img24.png"
                v-else
                class="icon-tag"
                alt=""
              />
              <div class="item-top">
                <img :src="item && item.headPicUrl" class="top-cover" alt=""/>
                <div class="top-con">
                  <div class="txt1">{{ item && item.realName }}</div>
                  <div class="txt2">
                    <span class="txt2-time">{{ item && item.times }}</span>
                  </div>
                </div>
              </div>
              <div class="con-div">
                <div class="item-title">{{ item && item.subjectName }}</div>
                <div class="item-cons" v-html="item.content"></div>
                <div class="item-imgs">
                  <div
                    :class="['type', item.contentFile.length ? '' : 'type_1']"
                  >
                    {{ typeObj[item.kind] }}
                  </div>
                  <div class="imgs-mask" v-if="item && item.isMoreImgs">
                    +{{ item && item.moreNum }}
                  </div>
                  <div class="boxs" v-if="!item.adminMaterialVideoId">
                    <template
                      v-if="
                        item.contentFile.length &&
                          allVideo.indexOf(
                            item.contentFile[0].format.toLocaleLowerCase()
                          ) > -1
                      "
                    >
                      <video
                        v-if="item && item.contentFile.length"
                        class="item_only_img"
                        controls
                        :src="item.contentFile[0].url"
                      ></video>
                    </template>
                    <template v-else>
                      <img
                        v-for="(item_img, index_img) in item.contentFile"
                        :key="index_img"
                        :src="item_img.url"
                        :class="
                          item.contentFile.length > 1
                            ? 'img-cover'
                            : 'item_only_img'
                        "
                        alt=""
                      />
                    </template>
                  </div>
                </div>
                <div
                  class="video-block"
                  v-if="
                    item.videoInfo &&
                      Object.keys(item.videoInfo).length > 0 &&
                      isPlayVideo
                  "
                >
                  <div
                    :style="
                      `background-image: url(${item.videoInfo.outUrl ||
                        item.videoInfo.path});`
                    "
                    class="video-block"
                    alt=""
                  ></div>
                  <img
                    src="@/assets/images/course/icon-play-course.png"
                    class="icon-play"
                    alt=""
                  />
                </div>
                <div class="work-div worked" v-if="`${item.isCutTime}` !== '1'">
                  <img
                    src="@/assets/images/zone/img32.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">待办任务作业</div>
                  <div class="work-btn">已过期</div>
                </div>
                <div
                  class="work-div"
                  v-else-if="
                    `${userInfo.memberType}` === '0' &&
                      item.areaPostbarWorkDataDTOS.length <= 0
                  "
                >
                  <img
                    src="@/assets/images/zone/img26.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">待办任务作业</div>
                  <div
                    class="work-check"
                    v-if="item.areaPostbarWorkDTO.length > 0"
                    @click.stop="handleClickItems(item, 'workdetails')"
                  >
                    <img
                      src="@/assets/images/zone/img31.png"
                      class="icon-check"
                      alt=""
                    />
                    <span class="check-txt">已批改</span>
                    <img
                      src="@/assets/images/zone/img23.png"
                      class="icon-more"
                      alt=""
                    />
                  </div>
                  <div
                    class="work-btn"
                    @click.stop="handleClickItems(item, 'worklist')"
                    v-else
                  >
                    批作业
                  </div>
                </div>
                <div
                  class="work-div"
                  v-else-if="
                    `${userInfo.memberType}` === '0' &&
                      item.areaPostbarWorkDataDTOS.length <= 0
                  "
                >
                  <img
                    src="@/assets/images/zone/img26.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">
                    待办任务作业-{{ item.tutorName }}导师
                  </div>
                  <div
                    class="work-check"
                    v-if="item.areaPostbarWorkDTO.length > 0"
                    @click.stop="handleClickItems(item, 'workdetails')"
                  >
                    <img
                      src="@/assets/images/zone/img31.png"
                      class="icon-check"
                      alt=""
                    />
                    <span class="check-txt">已作答</span>
                    <img
                      src="@/assets/images/zone/img23.png"
                      class="icon-more"
                      alt=""
                    />
                  </div>
                  <div
                    class="work-btn"
                    @click.stop="handleClickItems(item, 'answerwork')"
                    v-else
                  >
                    去完成
                  </div>
                </div>
                <div
                  class="work-div"
                  v-else-if="`${userInfo.memberType}` === '1'"
                >
                  <img
                    src="@/assets/images/zone/img26.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">待办任务作业</div>
                  <div
                    class="work-btn"
                    @click.stop="handleClickItems(item, 'worklist')"
                  >
                    查看
                  </div>
                </div>
                <div
                  class="work-tip"
                  v-if="
                    `${userInfo.memberType}` === '0' &&
                      item.areaPostbarWorkDataDTOS.length <= 0
                  "
                >
                  <div class="left-txt">截止时间:{{ item.curTimes }}</div>
                  <div class="right-txt">
                    {{
                      item.workFinishNum > 0 ? item.workFinishNum : 0
                    }}人已完成
                  </div>
                </div>
                <div
                  class="work-div"
                  v-if="
                    item.areaPostbarWorkDataDTOS &&
                      item.areaPostbarWorkDataDTOS.length > 0
                  "
                >
                  <img
                    src="@/assets/images/zone/img22.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">关联内容</div>
                  <div class="work-go">
                    {{ item.areaPostbarWorkDataDTOS[0].title }}
                    <img
                      src="@/assets/images/zone/img23.png"
                      class="icon-more"
                      alt=""
                    />
                  </div>
                </div>
                <div class="item-btm">
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img7.png"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.visitNum > 0 ? item.visitNum : 0
                      }}</span>
                  </div>
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img16.png"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.commentNum > 0 ? item.commentNum : 0
                      }}</span>
                  </div>
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img20.png"
                      v-if="item.isLike + '' === '1'"
                      class="icon-btm1"
                      alt=""
                    />
                    <img
                      src="@/assets/images/zone/img17.png"
                      v-if="item.isLike + '' === '2'"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.likeNum > 0 ? item.likeNum : 0
                      }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="[6,7,8,9].includes(item.type)">
              <ul class="home-menu">
                <li class="menu-li" @click="handleClickItems(item, 'comment')">
                  <template v-if="item.type !== 5">
                    <div class="li-head">
                      <img src="../../../assets/images/grade/home-iep.png" alt="" v-if="item.type === 6">
                      <img src="../../../assets/images/grade/home-answer.png" alt="" v-if="item.type === 7">
                      <img src="../../../assets/images/grade/home-mock.png" alt="" v-if="item.type === 8">
                      <img src="../../../assets/images/grade/icon-examine.png" alt="" v-if="item.type === 9">
                      <p class="head-title">{{ typeTitle[item.type] }}</p>
                    </div>
                    <ul class="item">
                      <li class="item-li" v-if="[6,7,9].includes(item.type)">
                        <p class="label">内容:</p>
                        <div class="value">
                          <p class="value-title" v-html="item.classContent"></p>
                        </div>
                      </li>
                      <li class="item-li" v-else>
                        <p class="label">类型:</p>
                        <div class="value">
                          <p class="value-title">{{ item.simulatorName }}</p>
                        </div>
                      </li>
                      <li class="item-li">
                        <p class="label">时间:</p>
                        <div class="value">
                          <p class="value-title">{{ item.dataTime }}</p>
                        </div>
                      </li>
                      <li class="item-li" v-if="[6, 8].includes(item.type)">
                        <p class="label">地点:</p>
                        <div class="value">
                          <p class="value-title">{{ item.place }}</p>
                        </div>
                      </li>
                      <li class="item-li" v-if="item.type === 7">
                        <p class="label">链接:</p>
                        <div class="value">
                          <div class="flex-val">
                            <div class="btn" @click.stop="handleGoMeeting(item.onlineLink)">进入会议</div>
                            <p class="val-title">{{ meetingStatusList[item.meetingStatus] }}</p>
                          </div>
                        </div>
                      </li>
                      <li class="item-li" v-if="item.type === 9">
                        <p class="label">链接:</p>
                        <div class="value">
                          <div class="flex-val">
                            <div class="btn" v-track="{ functionName: '进入班级考试' }"
                                 @click.stop="handleGoAnswer(item)">进入考试
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </template>
            <template v-else>
              <div class="item-top">
                <img :src="item && item.headPicUrl" class="top-cover" alt=""/>
                <div class="top-con">
                  <div class="txt1">{{ item && item.realName }}</div>
                  <div class="txt2">
                    <span class="txt2-time">{{ item && item.times }}发表了帖子</span>
                  </div>
                </div>
              </div>
              <div class="con-div">
                <div class="item-title">{{ item && item.subjectName }}</div>
                <div class="item-cons" v-html="item.content||item.classContent"></div>
                <div class="item-imgs">
                  <div
                    :class="['type', item.contentFile.length ? '' : 'type_1']"
                  >
                    {{ typeObj[item.kind] }}
                  </div>
                  <div class="imgs-mask" v-if="item && item.isMoreImgs">
                    +{{ item && item.moreNum }}
                  </div>
                  <div class="boxs" v-if="!item.adminMaterialVideoId">
                    <template v-if="item.type == 3">
                      <img
                        :src="item.areaPostbarLiveDTOS[0].liveCover"
                        class="item_only_img"
                        alt=""
                      />
                    </template>
                    <template v-else>
                      <template
                        v-if="
                          item.contentFile.length &&
                            allVideo.indexOf(
                              item.contentFile[0].format.toLocaleLowerCase()
                            ) > -1
                        "
                      >
                        <video
                          v-if="item && item.contentFile.length"
                          class="item_only_img"
                          controls
                          :src="item.contentFile[0].url"
                        ></video>
                      </template>
                      <template v-else>
                        <img
                          v-for="(item_img, index_img) in item.contentFile"
                          :key="index_img"
                          :src="item_img.url"
                          :class="
                            item.contentFile.length > 1
                              ? 'img-cover'
                              : 'item_only_img'
                          "
                          alt=""
                        />
                      </template>
                    </template>
                  </div>
                  <div
                    class="video-block"
                    v-if="
                      item.videoInfo &&
                        Object.keys(item.videoInfo).length > 0 &&
                        isPlayVideo
                    "
                  >
                    <div v-if="item.coverInfo" :style="`background-image: url(${item.coverInfo.url});`"
                         class="video-block" alt=""></div>
                    <div v-else :style="`background-image: url(${item.videoInfo.outUrl || item.videoInfo.path});`"
                         class="video-block" alt=""></div>
                    <img
                      src="@/assets/images/course/icon-play-course.png"
                      class="icon-play"
                      alt=""
                    />
                  </div>
                  <VideoPlayer
                    v-else-if="!isPlayVideo"
                    :ref="item.id"
                    :playerVideo="item.videoInfo"
                  ></VideoPlayer>
                  <template
                    v-if="
                      item.voteListSelectedDTOS &&
                        item.voteListSelectedDTOS.length > 0
                    "
                  >
                    <div class="vote-list">
                      <div
                        class="vote-show-div"
                        :class="item.voteAll ? 'auto' : ''"
                      >
                        <div
                          class="vote-item"
                          v-for="(item_vote,
                          index_vote) in item.voteListSelectedDTOS"
                          :key="index_vote"
                          :class="
                            item_vote.isSelected
                              ? 'item-checked'
                              : 'item-not-checked'
                          "
                          @click.stop="handleClickVoteItems(index, index_vote)"
                        >
                          <div class="txt-block">
                            <span class="txt">
                              {{ item_vote.content }}
                            </span>
                            <img
                              v-if="item_vote.isSelected"
                              src="@/assets/images/zone/img39.png"
                              :style="
                                `left: ${(item_vote.content.length + 1) *
                                  17}px;`
                              "
                              class="icon-checked"
                              alt=""
                            />
                          </div>
                          <div
                            class="process"
                            :style="
                              `width: ${(item_vote.selectNum /
                                item.allVotePerson) *
                                100}%;`
                            "
                          ></div>
                          <span class="num-txt">{{ item_vote.selectNum }}</span>
                        </div>
                      </div>
                      <div
                        class="vote-item"
                        v-if="
                          !item.voteAll && item.voteListSelectedDTOS.length >= 3
                        "
                        @click.stop="handleClickAll(index)"
                      >
                        查看全部选项
                        <img
                          src="@/assets/images/zone/img38.png"
                          class="icon-more"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="work-tip">
                      <div class="left-txt">{{ item.cutTimeStr }}</div>
                      <div class="right-txt">
                        {{ item.voteNum > 0 ? item.voteNum : 0 }}人参与
                      </div>
                    </div>
                  </template>
                </div>
                <div class="rea" v-if="changeActive == 2">
                  <div>驳回原因</div>
                  <div>{{ item.auditContent }}</div>
                </div>
                <div v-if="changeActive == 2" class="change">
                  <div class="btn" @click.stop="handleEdit(item)">修改内容</div>
                </div>
                <div v-if="changeActive != 2" class="item-btm">
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img7.png"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.visitNum > 0 ? item.visitNum : 0
                      }}</span>
                  </div>
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img16.png"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.commentNum > 0 ? item.commentNum : 0
                      }}</span>
                  </div>
                  <div class="btm-flex">
                    <img
                      src="@/assets/images/zone/img20.png"
                      v-if="item.isLike + '' === '1'"
                      class="icon-btm1"
                      alt=""
                    />
                    <img
                      v-if="item.isLike + '' === '2'"
                      src="@/assets/images/zone/img17.png"
                      class="icon-btm1"
                      alt=""
                    />
                    <span class="btm-num">{{
                        item.likeNum > 0 ? item.likeNum : 0
                      }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="empty-block" v-else>
          <img src="@/assets/images/zone/img18.png" class="empty-img" alt=""/>
          <div class="empty-txt">暂无内容</div>
        </div>
      </van-list>
    </div>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :dialogHeadTxt="dialogHeadTxt"
               :delMessage="delMessage"></dialogDel>
  </div>
</template>
<script>
import {userTypeObj, typeObj, allVideo} from '../data'
import {getDcc} from '@/api/dcc'
import {selectStock} from '@/api/zone'
// import { classUserPermissions } from '@/api/grade'
import VideoPlayer from '../../home/components/VideoPlayerAnswer.vue'
import dialogDel from '../../grade/components/dialogDel.vue'

export default {
  props: {
    areaId: '',
    active: ''
  },
  data() {
    return {
      load: false,
      delMessage: '确认删除吗?',
      dialogHeadTxt: '提示',
      // 筛选项分页
      postState: {
        pageNum: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      typeTitle: {
        6: 'iEP学习',
        7: '线上答疑',
        8: '模拟器练习',
        9: '班级考试',
      },
      meetingStatusList: {
        0: '未知',
        1: '进行中',
        2: '待开始',
        3: '已完成'
      },
      postListArr: [],
      userTypeObj,
      kind: null,
      typeObj,
      isPlayVideo: true,
      allVideo,
      changeActive: 1,
      commonPer: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  components: {dialogDel, VideoPlayer},
  methods: {
    init(active, kind) {
      this.postState.pageNum = 1
      this.postListArr = []
      this.postState.finished = true
      this.postState.finishText = ''
      this.kind = kind
      this.changeActive = active
      this.handleGetPostList()
    },
    // 进入会议
    handleGoMeeting(onlineLink) {
      window.open(onlineLink)
    },
    handleDelSave (item) {
      if (this.dialogConType === 'gradeQuestion') {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      }
    },
    handleGoAnswer(item) {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: '/gradeQuestion',
        note: `postId=${item.id}&classId=${item.areaId}`
      }))
      if (item.userInspectBusiness) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
          }
        })
      } else if (item.userInspectComplete) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      } else {
        this.dialogHeadTxt = '进入考试'
        const str = item.userResidueInspectNum >= 0 ? `, 还剩<span style="color: #EB1700;">${item.userResidueInspectNum}</span>次！` : ''
        this.delMessage = `您好，您本场考试的答题次数为第${item.userInspectNum}次${str}`
        this.$refs.dialogDel.init(item)
        this.dialogConType = 'gradeQuestion'
      }
    },
    // 获取用户班级角色权限
    getClassUserPermissions(item) {
      const PATHS2 = {
        6: '/iepDetails',
        7: '/answerDetails',
        8: '/mockDetails',
        9: '/examineDetail'
      }
      let path2 = PATHS2[item.type]
      let path = `${path2}?postId=${item.id}&classId=${item.areaId}&type=dcc`
      this.$router.push({
        path: path
      })
    },
    handleGetPostList() {
      let params = {
        auditStatus: this.changeActive,
        kind: this.kind,
        userId: this.userInfo.id,
        pageNum: this.postState.pageNum,
        pageSize: this.postState.pageSize
      }
      getDcc(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              return false
            }
            this.postState.finished = false
            this.postState.loading = false
            res.data.list = res.data.list.map(item => {
              item.times = this.$moment(item.createTime * 1).format(
                'MM-DD HH:mm'
              )
              item.curTimes =
                item.cutTime &&
                this.$moment(item.cutTime * 1).format('YYYY/MM/DD HH:mm')
              item.startTime = this.$moment(item.startTime * 1).format(
                'YYYY-MM-DD HH:mm'
              )
              item.endTime = this.$moment(item.endTime * 1).format(
                'YYYY-MM-DD HH:mm'
              )
              item.dataTime = `${item.startTime} ~ ${item.endTime}`
              if (item.contentFile.length > 3) {
                item.isMoreImgs = true
                item.moreNum = item.contentFile.length - 3
              }
              item.contentFile = item.contentFile.splice(0, 3)
              return item
            })
            res.data.list.forEach(async item => {
              if (item.adminMaterialVideoId) {
                const res = await selectStock({
                  mainId: item.adminMaterialVideoId
                })
                this.$set(item, 'videoInfo', res.data)
              }
              if (
                item.voteListSelectedDTOS &&
                item.voteListSelectedDTOS.length > 0
              ) {
                item.allVotePerson = 0
                item.voteListSelectedDTOS.map(items => {
                  item.allVotePerson += items.selectNum
                })
                item.voteAll = !(item.voteListSelectedDTOS.length >= 3)
                item.isChecked = !(
                  item.voteListSelectedDTOS.filter(res => res.isSelected)
                    .length > 0
                )
              }
            })

            console.log(res.data.list[0])

            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
              this.postState.finishText = '没有更多了'
            }
            if (res.code === 0 && res.data.list) {
              this.$nextTick(() => {
                this.postListArr = this.postListArr.concat(res.data.list)
              })
            }
            this.postState.pageNum++
            if (this.postListArr.length === 0) {
              this.postState.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    handleClickItems(item, type) {
      let path, query
      path = '/dccDetail'
      query = {
        postId: item.id,
        status: item.auditStatus,
        type: 'dcc',
        areaId: item.areaId,
        entrance: 91,
        channel: 91,
        businessId: item.areaId,
      }
      if (item.kind === 4) {
        if ([6, 7, 8, 9].includes(item.type)) {
          this.classId = item.areaId
          return this.getClassUserPermissions(item)
        } else {
          path = '/topicDetail'
          query = {
            postId: item.id,
            status: item.auditStatus,
            type: 'dcc',
            isAuthority: true,
            entrance: 91,
            channel: 91,
          }
        }
      }
      if (type === 'answerwork') {
        path = '/answerWork'
        query = {
          postId: item.id,
          areaId: item.areaId
        }
      }
      if (type === 'workdetails') {
        path = '/workDetails'
        query = {
          workId: item.areaPostbarWorkDTO[0].id,
          workType: 'answer',
          areaId: item.areaId
        }
      }
      if (type === 'worklist') {
        path = '/workList'
        query = {
          postId: item.id,
          areaId: item.areaId
        }
      }
      this.$router.push({
        path,
        query
      })
    },
    handleEdit(item) {
      console.log(item.type, item)
      let path = ''
      if (`${item.type}` === '5') {
        path = `/addGradePost?areaId=${item.areaId}&dccId=${item.id}`
      }
      if (`${item.type}` === '4') {
        path = `/addWork?areaId=${item.areaId}&dccId=${item.id}`
      }
      if (`${item.type}` === '3') {
        path = `/livePreview?areaId=${item.areaId}&dccId=${item.id}`
      }
      if (`${item.type}` === '2') {
        path = `/addVote?areaId=${item.areaId}&dccId=${item.id}`
      }
      if (`${item.type}` === '1') {
        path = `/addPost?areaId=${item.areaId}&dccId=${item.id}`
      }
      this.$router.push({
        path
      })
    },
    handleClickItemsVideo(item) {
      this.isPlayVideo = !this.isPlayVideo
      setTimeout(() => {
        let videos = this.$refs[item.id]
        videos.player.play()
      })
    },
    handleClickAll(index) {
      this.postListArr[index].voteAll = !this.postListArr[index].voteAll
    }
  }
}
</script>
<style lang="less" scoped>
.section-block {
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
  padding: 16px;
  padding-top: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 260px);
}

.block1-list {
  .block1-item {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 12px;
    border: 1px solid #fff;
    box-sizing: border-box;
    position: relative;

    .icon-tag {
      width: 27px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-top {
      display: flex;
      align-items: center;
      padding: 10px;
      border: 1px solid #fff;
      box-sizing: border-box;
      background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);
      border-radius: 12px 12px 0 0;

      .top-cover {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 4px;
      }

      .top-con {
        display: flex;
        flex-direction: column;

        .txt1 {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
        }

        .txt2 {
          display: flex;
          align-items: center;

          .txt2-tag {
            width: 40px;
            height: 14px;
            border-radius: 2px;
            border: 1px solid #EB1700;
            margin-right: 4px;
            color: #EB1700;
            font-size: 10px;
            text-align: center;
          }

          .txt2-time {
            font-size: 12px;
            font-weight: 500;
            color: #7a8494;
          }
        }
      }
    }

    .con-div {
      padding: 10px;
      padding-bottom: 0;
      box-sizing: border-box;

      .item-title {
        font-size: 14px;
        color: #202020;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 5px;
      }

      .item-cons {
        font-size: 12px;
        color: #7a8494;
        line-height: 20px;
        margin-bottom: 4px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .item-imgs {
        position: relative;
        min-height: 15px;

        .boxs {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
        }

        .img-cover {
          width: 100px;
          margin-right: 10px;
          height: 100px;
          display: block;
          border-radius: 4px;

          &:nth-last-child(1) {
            margin-right: 0;
          }
        }

        .item_only_img {
          width: 100%;
          height: 178px;
        }

        .imgs-mask {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          height: 100px;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
        }

        .type {
          padding: 0 4px;
          box-sizing: border-box;
          height: 15px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 0px 8px 0px 0px;
          line-height: 15px;
          position: absolute;
          left: 0;
          bottom: 0;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 12px;
          color: #000000;
          z-index: 99;
        }

        .type_1 {
          background: rgba(0, 0, 0, 0.08);
        }

        .video-cover {
          width: 100%;
          height: 152px;
          object-fit: cover;
        }

        .icon-video {
          position: absolute;
          width: 40px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .item-comment {
        background-color: #f6f6f6;
        padding: 10px 8px;
        box-sizing: border-box;
        margin-top: 10px;
        border-radius: 4px;

        .comment-block {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .head-cover {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            display: block;
          }

          .comment-txt {
            font-size: 12px;
            color: #343434;
          }
        }
      }
    }

    .con-div1 {
      padding-bottom: 10px;
    }

    .work-div {
      display: flex;
      align-items: center;
      padding-right: 10px;
      box-sizing: border-box;
      background: linear-gradient(180deg, #fff0ef 0%, #fff5ee 100%);
      border-radius: 4px;
      height: 32px;
      margin-top: 10px;

      &.worked {
        background: #f6f6f6;

        .work-btn {
          background: #dfdddd;
          color: #7a8494;
          box-shadow: none;
        }
      }

      .icon-word {
        width: 29px;
        height: 29px;
        display: block;
        margin-right: 4px;
        transform: translateY(2px);
      }

      .work-txt {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #202020;
        white-space: nowrap;
      }

      .work-go {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #EB1700;

        .icon-more {
          width: 13px;
          display: block;
          margin-left: 4px;
          transform: translateY(2px);
        }
      }

      .work-btn {
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        border-radius: 4px;
        width: 44px;
        height: 18px;
        line-height: 18px;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }

      .work-check {
        display: flex;
        align-items: center;
        height: 22px;

        .icon-check {
          display: block;
          width: 22px;
          height: 22px;
          transform: translateY(2px);
        }

        .check-txt {
          padding: 0 2px;
          box-sizing: border-box;
          font-size: 14px;
          color: #EB1700;
        }

        .icon-more {
          display: block;
          width: 12px;
          transform: translateY(2px);
        }
      }
    }

    .work-tip {
      margin-top: 10px;
      height: 20px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 35px;
      box-sizing: border-box;

      .left-txt {
        font-size: 13px;
        color: #7a8494;
      }

      .right-txt {
        font-size: 14px;
        color: #7a8494;
      }
    }

    .item-btm {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .btm-flex {
        display: flex;
        align-items: center;
        height: 40px;

        .icon-btm1 {
          width: 16px;
          margin-right: 4px;
          display: block;
        }

        .btm-num {
          line-height: 40px;
          font-size: 12px;
          color: #7a8494;
          display: block;
          transform: translateY(2px);
        }
      }
    }
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
    margin: 0 auto;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}

.rea {
  width: 323px;
  background: #f2f3f7;
  border-radius: 30px;
  padding: 8px;
  box-sizing: border-box;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #7a8494;
  margin-top: 9px;
}

.change {
  width: 100%;
  text-align: right;
  padding: 10px;
  box-sizing: border-box;

  .btn {
    display: inline-block;
    width: 63px;
    height: 22px;
    border-radius: 30px;
    border: 1px solid #EB1700;
    text-align: center;
    font-family: Be Vietnam Pro, Be Vietnam Pro;
    font-weight: 400;
    font-size: 12px;
    color: #EB1700;
    line-height: 22px;
  }
}

.video-block {
  width: 100%;
  height: 200px;
  position: relative;
  object-fit: cover;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  .icon-play {
    position: absolute;
    width: 40px;
    display: block;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}

.vote-list {
  margin-top: 8px;

  .vote-show-div {
    overflow: hidden;
    height: 84px;

    &.auto {
      height: auto;
    }
  }

  .vote-item {
    width: 100%;
    padding: 6px 0;
    border: 1px solid #e8e8e8;
    box-sizing: border-box;
    margin-bottom: 6px;
    border-radius: 4px;
    color: #EB1700;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.item-submit {
      background-color: #EB1700;
      color: #fff;
    }

    .process {
      width: 0;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .txt-block {
      display: flex;
      align-items: center;

      .txt {
        position: relative;
        z-index: 1;
        max-width: 240px;
        margin-right: 10px;
      }
    }

    .num-txt {
      font-size: 14px;
      position: relative;
      z-index: 1;
    }

    &.item-checked {
      border-color: #EB1700;
      justify-content: space-between;
      padding-left: 14px;
      padding-right: 14px;
      box-sizing: border-box;
      position: relative;

      .process {
        background-color: rgba(255, 91, 12, 0.1);
      }

      .num-txt {
        color: #EB1700;
      }

      .icon-checked {
        width: 14px;
      }
    }

    &.item-not-checked {
      border-color: #e8e8e8;
      justify-content: space-between;
      padding-left: 14px;
      padding-right: 14px;
      box-sizing: border-box;
      position: relative;
      color: #333333;

      .process {
        background-color: #f6f6f6;
      }

      .num-txt {
        color: #333333;
      }
    }

    .icon-more {
      display: block;
      width: 4px;
      margin-left: 4px;
    }
  }
}

.home-menu {
  margin: 0;
  padding: 0;

  .menu-li {
    border-radius: 12px;
    // height: 201px;
    background: #FFFFFF;
    margin-bottom: 12px;
    position: relative;
    display: flex;
    flex-direction: column;

    .li-head {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      height: 41px;
      position: relative;
      display: flex;
      align-items: center;
      padding: 9px 9px 8px;
      box-sizing: border-box;
      border: 1.5px solid rgb(255, 255, 255);
      /* 用户渐变 */
      background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);

      img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }

      .head-title {
        font-weight: 600;
        font-size: 14px;
        color: #202020;
      }
    }

    .item {
      // flex:1;
      height: calc(100% - 41px - 42px);
      position: relative;
      padding: 10px 30px 10px 12px;

      .item-li {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          font-weight: 500;
          font-size: 14px;
          color: #7A8494;
          margin-right: 6px;
        }

        .value {
          flex: 1;
          overflow: hidden;

          .value-title {
            width: 100%;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .flex-val {
            display: flex;
            align-items: center;

            .btn {
              width: 89px;
              height: 32px;
              background: #EB1700;
              border-radius: 25px;
              margin-right: 10px;
              font-size: 12px;
              color: #FFFFFF;
              text-align: center;
              line-height: 31px;
            }

            .val-title {
              font-weight: 500;
              font-size: 14px;
              color: #7A8494;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/dccList.vue